var videos = {

	$fullVideo: $('.full-video'),
	$videoCover: $('.video-cover'),
	$brightCoveClient: $('[data-video-client="brightcove"]'),
	moving: false,
	coverFadingOut: false,

	onStateChange: function(event) {
		var _this = $(event.target.a);
		if (_this.closest('.slider-hero-extended').length) {
			var _event = event.data;
			var contentSlider = $('.slider-hero-content');
			if (_event === 1) {
				contentSlider.addClass('slider-video-playing');
			} else if (_event === 0 || _event === 2) {
				contentSlider.removeClass('slider-video-playing');
			}
		}
	},

	/*
		Pause any video (primary or secundary) that is currently playing
	*/
	pauseOther: function() {
		var activeYoutube = $('.youtube-video.active');
		if (activeYoutube.length > 0) {
			activeYoutube.each(function(){
				var thisYoutube = $(this).closest('.full-video').find('iframe').attr('id');
				players[thisYoutube].stopVideo();
			});
		}

		var videoId = $( '.vjs-playing' ).find('video').attr('id');

		// $('.header-logo').append('<br/>!!!pauseOther():', z,',videoId:',videoId);

		if (videoId) {
				videojs(videoId).pause();
				videojs(videoId).currentTime(0);
		}
	},

	mobileVIdPlay: function(vcode, width, height){
  	$(".mobile-video").html('<iframe width="'+width+'" height="'+height+'" src="https://www.youtube.com/embed/'+vcode+'?autoplay=1&loop=1&rel=0&wmode=transparent" frameborder="0" allowfullscreen wmode="Opaque"></iframe>');
	},

	playVideo: function($targetVideoCover, isMobile) {
		if (!videos.moving) {

			videos.pauseOther();
			var videoClient = $targetVideoCover.attr('data-video-client');

			$('.hidden-cover').removeClass('hidden-cover').fadeIn('fast');
			$targetVideoCover.addClass('hidden-cover').fadeOut('fast', function(){
				videos.coverFadingOut = false;
			});

			if (videoClient === 'brightcove') {
				var thisBrighcove = $targetVideoCover.closest('.full-video').find('.video-brightcove');
				var videoId = thisBrighcove.find('video').attr('id');
				if(videoId==undefined){
					return;
				}

				videojs(videoId).play();
				if(videoId==undefined){
					return;
				}

				if ($targetVideoCover.closest('.slider-hero-extended').length) {
					var contentSlider = $('.slider-hero-content');
					$targetVideoCover.closest('.full-video').find('video').on('ended pause', function(){
						contentSlider.removeClass('slider-video-playing');
					});

					$targetVideoCover.closest('.full-video').find('video').on('play', function(){
						contentSlider.addClass('slider-video-playing');
					});
				}
			} else if (videoClient === 'youtube') {
				$targetVideoCover.closest('.full-video').find('.youtube-video').addClass('active');
				var videoId = $targetVideoCover.attr('data-video-trigger');

				if (isIOS === false) {
					players[videoId].playVideo();
				}
			} else {
				return;
			}
			videos.moving = false;
			return;
		}
	},

	//center the primary video vertically in the remaining area (excluding the carousel controls)
	verticallyCenterVideo: function() {
		$header = $('.main-header');
		$sliderSyncComplex = $('.slider-sync-complex');
		$videoEls = $('.main-video .vjs-tech');
		if ($header.length && $sliderSyncComplex.length && $videoEls.length){
			// need to investigate further while not centering perfectly. at the moment use this magic number
			videoTop = $sliderSyncComplex.offset().top/2 - $header.height()/2 + 9;
			$videoEls.attr('style', 'top: ' + String(videoTop) + 'px !important');
		}
	},

	eventListeners: function() {
		videos.$videoCover.on('mousedown', function(){
			videos.moving = false;
		});
		videos.$videoCover.on('mouseup', function(e) {
			var windowWidth = $(window).width();

			slider.syncComplex.slick('slickPause');

			if (videos.coverFadingOut){ return; }

			videos.coverFadingOut = true;
			videos.playVideo($(e.target).closest('.video-cover'));

			if (isTouch && $(e.target).closest('.slider-sync-simple').length) {
				// slider.syncComplex.addClass('move-down');
				slider.syncComplex.slick('slickPause');
				videos.verticallyCenterVideo();
			}
		});
	},

	pageHeroVideo: function() {
		if (!isTouch) {
			var heroCover = $('.module-hero-new.contains-video').find('.video-cover');
			videos.playVideo(heroCover, false);
		}
	},

	init: function() {
		if (videos.$fullVideo.length > 0) {
			videos.eventListeners();
		}
		if (isTouch) {
			videos.verticallyCenterVideo();
		}

		if ($('.module-hero-new.contains-video').length) {
			videos.pageHeroVideo();
		}
	}
};

window.videos = videos;
